<div class="fx-layout-row fx-layout-align-center-center">
  <div class="fx-flex-80pc">
    <div class="row">
      <h4>Course Payments for {{ member.fname }} {{ member.lname }}</h4>
    </div>
    <p-table #dt [columns]="cols" [value]="memberPayments" [paginator]="true" [rows]="rows"
      [totalRecords]="totalRecords" [loading]="loading"
      [tableStyle]="{'table-layout':'auto'}" styleClass="p-datatable-gridlines">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field === 'actions' ? null : col.field">
            {{ col.header }}
            <p-sortIcon *ngIf="col.field !== 'actions'" [field]="col.field" ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
            </p-sortIcon>
          </th>
        </tr>
        <tr>
          <th *ngFor="let col of columns" [ngSwitch]="col.field">
            <input *ngSwitchCase="'paymentId'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'paymentType'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'courseCode'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'amount'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'email'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'paymentDate'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'paymentNote'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'stripePaymentIntentId'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'stripeCheckoutSessionId'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'memberCourse'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <span *ngSwitchCase="'actions'"></span>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td *ngFor="let col of columns">
            <span *ngIf="col.field === 'paymentDate'">{{ rowData[col.field] | date: 'shortDate' }}</span>
            <span *ngIf="col.field === 'amount'">{{ rowData[col.field] | number: '1.2-2' }}</span>
            <span *ngIf="col.field === 'memberCourse'">
              {{ getMemberCourseDisplayName(getMemberCourseForPayment(rowData)) || '-' }}
            </span>
            <span *ngIf="col.field === 'actions'">
              <button type="button" pButton icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm"
                (click)="showDialogToEdit(rowData)" title="Edit payment" aria-label="Edit payment"></button>
            </span>
            <span *ngIf="col.field !== 'paymentDate' && col.field !== 'amount' && col.field !== 'memberCourse' && col.field !== 'actions'">{{ rowData[col.field] }}</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="cols.length">No course payments found.</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div style="text-align:left">
          <button type="button" pButton (click)="showDialogToAdd()" label="Add Payment"></button>
        </div>
      </ng-template>
    </p-table>

    <p-dialog [header]="isEditMode ? 'Edit Payment' : 'Add Payment'" [(visible)]="displayDialog" [responsive]="true" showEffect="fade" [modal]="true"
      [style]="{width: '700px'}">
      <div class="red-text" *ngIf="errorMessage">{{ errorMessage }}</div>
      <div class="alert-success" *ngIf="successMessage">{{ successMessage }}</div>
      <div class="ui-g ui-fluid" *ngIf="newPayment">
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="paymentType">Payment Type*</label>
          </div>
          <div class="ui-g-8 pad0">
            <p-dropdown class="margin0" id="paymentType"
              [options]="paymentTypeDropdownOptions"
              [(ngModel)]="newPayment.paymentType"
              placeholder="Select payment type"
              required>
            </p-dropdown>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="courseCode">Course Code*</label>
          </div>
          <div class="ui-g-8 pad0">
            <p-dropdown class="margin0" [options]="courseCodeOptions" [(ngModel)]="newPayment.courseCode"
              (ngModelChange)="onCourseCodeChange($event)"
              placeholder="Select Course Code" required></p-dropdown>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="memberCourseId">Member Course*</label>
          </div>
          <div class="ui-g-8 pad0">
            <p-dropdown class="margin0" id="memberCourseId" [options]="memberCourseOptions"
              [(ngModel)]="newPayment.memberCourseId"
              placeholder="Select Member Course" required></p-dropdown>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="amount">Amount*</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText type="number" class="margin0" id="amount" [(ngModel)]="newPayment.amount" required />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="email">Email*</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText type="email" class="margin0" id="email" [(ngModel)]="newPayment.email" required />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="paymentDate">Payment Date*</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText type="date" class="margin0" id="paymentDate" 
              [ngModel]="getDateString(newPayment.paymentDate)" 
              (ngModelChange)="onPaymentDateChange($event)" required />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="paymentNote">Payment Note</label>
          </div>
          <div class="ui-g-8 pad0">
            <textarea pInputTextarea class="margin0" id="paymentNote" [(ngModel)]="newPayment.paymentNote" rows="3"></textarea>
          </div>
        </div>
      </div>
      <ng-template pTemplate="footer">
        <div class="ui-dialog-buttonpane ui-helper-clearfix">
          <button type="button" pButton (click)="save()"
            [disabled]="!newPayment || !newPayment.paymentType || !newPayment.courseCode || !newPayment.memberCourseId || !newPayment.amount || !newPayment.email"
            [label]="isEditMode ? 'Update' : 'Save'"></button>
          <button type="button" pButton (click)="displayDialog = false" label="Cancel"></button>
        </div>
      </ng-template>
    </p-dialog>
  </div>
</div>
